import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { IServerConfiguration } from './serverConfiguration.interface';

@Injectable()
export class AppSettingsService {
    private appConfig;
    private configuration: IServerConfiguration;
    private httpHeaders: HttpHeaders;

    constructor(private http: HttpClient) { }

    loadAppConfig() {
      // const jsonFile = 'assets/config/tsconfig.json';
      // return new Promise<void>((resolve, reject) => {
      //   this.http.get(jsonFile).toPromise().then((response: IServerConfiguration) => {
      //     this.configuration = <IServerConfiguration>response;
      //     resolve();
      //   }).catch((response: any) => {
      //     reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
      //   });
      // });
    }

    getApiAddress() {
        // return this.configuration.apiUrl;
        return 'api';
    }

    getHeadersConfig() {
      const headerJson = {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
          'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
          'token': ` ${localStorage.getItem('userToken')}`
        };
      const headersConfig = new HttpHeaders(headerJson);
      return headersConfig;
    }
}
